import type { ComponentPropsWithoutRef } from "react";

import { type Humidifier as HumidifierType } from "@eisox/api/core-api";
import { cn } from "@eisox/design-system";
import { DropletIcon } from "@eisox/icons";

import { Position, type Component } from "../types";
import { Card } from "./card";

interface HumidifierProps extends Omit<HumidifierType, "id">, Component, ComponentPropsWithoutRef<"div"> {}

const Humidifier: React.FC<HumidifierProps> = ({
  humidity,
  defect = false,
  missmatchDefect = false,
  position = Position.TOP,
  commandType: _commandType,
  ...props
}) => (
  <div
    className={cn("gap-1.25 flex w-fit flex-col items-center", position === Position.BOTTOM && "flex-col-reverse")}
    {...props}
    style={{ cursor: props.onClick ? "pointer" : "default" }}
  >
    <Card className="gap-1.25 flex items-center" defect={defect || missmatchDefect} position={position}>
      <DropletIcon />
      {humidity !== undefined && `${humidity.toFixed(1)} %`}
    </Card>
  </div>
);

Humidifier.displayName = "Humidifier";

export { Humidifier };
export type { HumidifierProps };
